// apps/vrw-cp - ミッション詳細ページ
import React from "react";
import { GetStaticPaths, GetStaticProps } from "next";

import { MissionPage } from "@vrw-guppy/react-vrw";
import OgpHead from "@/components/OgpHead";
import { MissionReadResponse } from "@/lib/models/mission";
import { getItem } from "@/lib/apiClient";

type GetItemProps = {
  item: MissionReadResponse;
  pk: string;
};

/**
 * ミッション詳細データをISRで取得する
 */
export const getStaticProps: GetStaticProps<GetItemProps> = async (context) => {
  const { type, pk } = context.params as { pk: string; type: string };
  try {
    const item = await getItem({
      type: type as string,
      pk: pk as string,
    });

    return {
      props: {
        item,
        pk,
      },
      revalidate: 60,
    };
  } catch (e: any) {
    if (String(e).includes("404")) {
      // 404エラー時はnotFoundを返す
      return {
        notFound: true,
        revalidate: 60,
      };
    }
    // その他のエラーはthrow
    throw e;
  }
};

/**
 * 動的パスをブロッキングで生成する
 */
export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: "blocking" };
};

const App = ({ item }: GetItemProps) => {
  return (
    <>
      <OgpHead
        title={"ミッション情報 : " + item.name}
        thumbnailUrl={item.image_url}
      />
      <MissionPage item={item} />
    </>
  );
};

export default App;
